// ═══════════════════════════════════════════════════════════════
//  Runtime-aware API Config
// ═══════════════════════════════════════════════════════════════
// Priority order:
//   1. window.__RUNTIME_CONFIG__  (Docker runtime — set by env.sh)
//   2. process.env.REACT_APP_*    (CRA build-time — local dev)
//   3. Hardcoded fallback         (last resort)
// ═══════════════════════════════════════════════════════════════

interface RuntimeConfig {
    API_BASE_URL?: string;
}

// Extend Window to include our runtime config
declare global {
    interface Window {
        __RUNTIME_CONFIG__?: RuntimeConfig;
    }
}

/**
 * Resolve a config value with priority:
 *   runtime (Docker) → build-time (CRA .env) → fallback
 */
function getConfigValue(
    runtimeKey: keyof RuntimeConfig,
    buildTimeEnvVar: string | undefined,
    fallback: string
): string {
    const runtimeVal = window.__RUNTIME_CONFIG__?.[runtimeKey];
    // Runtime value wins if it's a non-empty string
    if (runtimeVal && runtimeVal.trim() !== "") {
        return runtimeVal;
    }
    // Then try CRA build-time env
    if (buildTimeEnvVar && buildTimeEnvVar.trim() !== "") {
        return buildTimeEnvVar;
    }
    // Last resort fallback
    return fallback;
}

const API_BASE_URL = getConfigValue(
    "API_BASE_URL",
    process.env.REACT_APP_GENERATED_BACKEND_URL,
    "http://localhost:8082/api"
);

const apiConfig = {

    // This is the base URL for the Designer Backend (for metadata)

    API_BASE_URL,

    // This function should point to the generated backend's data endpoint for a resource

    getResourceUrl: (resourceName: string) => API_BASE_URL + "/" + resourceName.toLowerCase(),

    // This function should point to the Designer Backend's metadata endpoint for a resource

    getResourceMetaDataUrl: (resourceName: string) => API_BASE_URL + "/getAllResourceMetaData/" + resourceName.toLowerCase(),

};

export default apiConfig;